import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { NbToastrService, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-setting-stat',
  templateUrl: './setting-stat.component.html',
  styleUrls: ['./setting-stat.component.scss']
})
export class SettingStatComponent implements OnInit {
  investisseurs;
  programmes;
  projets;
  hideLoader = true;
hideButon;
@ViewChild('userRegistrationForm',{static:true}) myForm; 
  constructor(protected dialogRef: NbDialogRef< SettingStatComponent>,private apiService:ApiService,public toastr:NbToastrService, private router: Router) { }

  ngOnInit() {
    this.getStat();
  }

  cancel(){
    this.dialogRef.close();
  }

  getStat(){
    this.apiService.getParametresStatProvider().subscribe((data:any) =>{
      this.programmes = data.programmes;
      this.projets = data.projets;
      this.investisseurs = data.investisseurs;
    })
  }

  updateStat(){
    this.hideLoader = false;
    this.hideButon = true;
    this.apiService.updateParametresStatProvider(this.investisseurs,this.programmes,this.projets).subscribe(data =>{
      console.log(data);
      this.toastr.success("mise à jour réussie","success");
      // this.myForm.resetForm();
      this.hideLoader = true;
      this.hideButon = false;
    },(err) =>{
      this.hideLoader = true;
      this.hideButon = false;
      this.toastr.danger("Echec de mise à jour","erreur");
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }

}
